import { FilmScreening } from '@/app/[festival-slug]/[locale]/(rest)/films/[slug]/components/ScreeningList';
import { formatDate } from '@/utils/date-format';
import { cn } from '@/utils/tailwind-merge';
import { useTranslations } from 'next-intl';
import Button from '../ui/Button';
import ThemedIcon from '../ui/ThemedIcon';

export enum ScreeningType {
    'ONLINE' = 'virtualExclusive',
    'OFFLINE' = 'inCinema',
}

const Screening = ({
    screening: {
        start_time: date,
        location: { name: place, address: description },
    },
    onAddToBasket,
    onRemoveFromBasket,
    isAddedInitially,
    disabled,
}: {
    screening: FilmScreening;
    onAddToBasket: () => void;
    onRemoveFromBasket: () => void;
    isAddedInitially: boolean;
    disabled?: boolean;
}) => {
    const t = useTranslations('Cart');
    // Derive state directly from prop to avoid sync issues
    const isAdded = isAddedInitially || false;

    const handleAddToBasket = () => {
        if (!isAdded) {
            onAddToBasket();
        } else {
            onRemoveFromBasket();
        }
    };

    return (
        <div className="flex flex-col">
            <span className="font-helvetica-neue font-light text-p max-lg:text-[12px] text-tofu w-full border-b border-white">
                {formatDate(date)}
            </span>
            <div className="flex gap-10 justify-between pt-5 items-end max-lg:flex-col max-lg:items-start max-lg:gap-5">
                <div className="flex flex-col">
                    <h5 className="text-[22px] lg:text-[28px] uppercase text-white">{place}</h5>
                    <p className="font-helvetica-neue font-light text-p text-tofu max-lg:text-[12px]">
                        {description}
                    </p>
                    {/* {ticket && (
                        <div className="mt-2 flex flex-col gap-1">
                            <p className="font-helvetica-neue font-light text-sm text-tofu">
                                <span>
                                    Price:{' '}
                                    <span className="text-white">
                                        $
                                        {hasSpecialPrice(screening)
                                            ? getEffectivePrice(ticket, screening)
                                            : ticket.price}
                                    </span>
                                </span>
                            </p>
                        </div>
                    )} */}
                </div>
                <Button
                    className={cn(
                        `max-w-80 w-full border-primary border border-solid py-3 px-20 h-fit transition-colors duration-300 ${
                            isAdded ? 'bg-primary text-white' : ''
                        }`,
                        disabled && 'opacity-50 cursor-not-allowed',
                    )}
                    onClick={handleAddToBasket}
                    variant="primary"
                    title={disabled ? t('notAvailable') : isAdded ? t('added') : t('addToBasket')}
                    textClasses="font-trade-gothic font-normal text-white"
                    disabled={disabled}
                >
                    <ThemedIcon
                        aria-label="Basket icon"
                        className={cn('ml-4 text-primary', isAdded && 'text-text-primary')}
                        src="/img/icons/basket.svg"
                        width={36}
                        height={36}
                    />
                </Button>
            </div>
        </div>
    );
};

export default Screening;
